import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, inrFormatter} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;

    console.log("Chart vizName called:", vizName)

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const radius = chart.width > 500 ? 5 : 3;
    const opacity = {normal: 0.7, focus: 1, muted: 0.2, hidden: 0};

    var x1AxisLabel = d3.scaleLinear().rangeRound([0, chart.width]);
    var y1AxisLabel = d3.scaleBand().range([chart.height, 0]);

    var xAxisTop = d3.axisTop(x1AxisLabel).tickSize(0);
    var xAxisBottom = d3.axisBottom(x1AxisLabel).tickSize(0);

    var familyLine = d3.line()
        .x((d) => {
            return d.x;
        })
        .y((d) => {
            return d.y;
        })
        .curve(d3.curveLinear);

    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("viewBox", "-50 0 " + chart.width + " " + (chart.height + chart.margin.top + chart.margin.bottom))
        .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
        .on("click", () => {
            resetChart()
        })
    //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

    var g = svg.append("g").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    // LOAD DATA AND CREATE CHARTS
    axios.post(url, filterParam).then(res => {
        let data = res.data;
        var averageROI = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            .rollup(function (v) {
                return d3.max(v, function (d) {
                    return d.metric1;
                });
            })
            .entries(data);

        // SET THE SCALES
        x1AxisLabel.domain([
            d3.min(data, function (d) {
                return d.metric1;
            }),
            d3.max(data, function (d) {
                return d.metric1;
            }),
        ]);

        y1AxisLabel.domain(data.sort(function (a, b) {
            return b.metric1 - a.metric1;
        })
            .map(function (d) {
                return d.dim1_name;
            }));

        metric1ColorScale.domain(x1AxisLabel.domain());
        metric1ColorScale.domain(data.sort(function (a, b) {
            return b.metric1 - a.metric1;
        })
            .map(function (d) {
                return d.dim2_name;
            }));

        xAxisTop.ticks((x1AxisLabel.domain()[1] - x1AxisLabel.domain()[0] + 1));
        xAxisBottom.ticks((x1AxisLabel.domain()[1] - x1AxisLabel.domain()[0] + 1));

        // DRAW THE LABELS AND GRID LINES

        var yLabels = g.selectAll(".y-label")
            .data(y1AxisLabel.domain())
            .enter()
            .append("text")
            .attr("text-anchor", "end")
            .attr("y", function (d) {
                return y1AxisLabel(d) + y1AxisLabel.bandwidth() / 2;
            })
            .attr("x", -10)
            .text(function (d) {
                return capitalizeFirstLetter(d);
            });

        console.warn(yLabels)

        var gXAxisTop = g.append("g")
            .attr("class", "axis-top")
            .attr("transform", "translate(0,0)")
            .call(xAxisTop);

        const arrowMargin = 10;

        gXAxisTop.append("text")
            .text("Negative return")
            .attr("x", x1AxisLabel(1) - arrowMargin)
            .attr("y", -arrowMargin)
            .attr("text-anchor", "end");

        gXAxisTop.append("text")
            .text("Postive return")
            .attr("x", x1AxisLabel(1) + arrowMargin)
            .attr("y", -arrowMargin)
            .attr("text-anchor", "start");

        //arrow head
        gXAxisTop.append("defs")
            .append("marker")
            .attr("id", "arrowhead-bottom")
            .attr("shape-rendering", "auto")
            .attr("stroke", "#D1D3D4")
            .attr("fill", "none")
            .attr("markerWidth", "13")
            .attr("markerHeight", "13")
            .attr("refX", "8")
            .attr("refY", "6")
            .attr("orient", "auto")
            .append("svg:path")
            .attr("d", "M1,1 L8,6 L1,11 ");

        var arrow = gXAxisTop.append("g")
            .attr("shape-rendering", "auto")
            .attr("stroke", "#D1D3D4")
            .attr("fill", "none")
            .attr("transform", "translate(" + x1AxisLabel(1) + "," + -6 + ")");

        arrow.append("line")
            .attr("shape-rendering", "auto")
            .attr("stroke", "#D1D3D4")
            .attr("fill", "none")
            .attr("x1", arrowMargin)
            .attr("y1", 0)
            .attr("x2", 200)
            .attr("y2", 0)
            .attr("marker-end", "url(#arrowhead-bottom)");

        arrow.append("line")
            .attr("shape-rendering", "auto")
            .attr("stroke", "#D1D3D4")
            .attr("fill", "none")
            .attr("x1", -arrowMargin)
            .attr("y1", 0)
            .attr("x2", -100)
            .attr("y2", 0)
            .attr("marker-end", "url(#arrowhead-bottom)");

        gXAxisTop.selectAll(".tick").selectAll("text")
            .text(function (d) {
                return d === 1 ? "" : "Margin: " + d;
            });

        var gridLines = g.selectAll(".axis-top").selectAll(".tick")
            .append("line")
            .attr("stroke-dasharray", 2, 2)
            .attr("stroke", "#D1D3D4")
            .attr("fill", "none")
            .attr("x1", 0)
            .attr("y1", function (d) {
                return d === 1 ? -chart.margin.top : 0;
            })
            .attr("x2", 0)
            .attr("y2", chart.height);

        console.warn(gridLines)

        var gXAxisBottom = g.append("g")
            .attr("class", "axis-bottom")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(xAxisBottom);

        gXAxisBottom.selectAll(".tick").selectAll("text")
            .text(function (d) {
                return "Margin: " + d;
            });

        var avgLines = g.selectAll(".avg-lines")
            .data(averageROI)
            .enter()
            .append("g")
            .attr("class", "avg-line")
            .attr("transform", (d) => {
                return "translate(" + x1AxisLabel(d.value) + "," + y1AxisLabel(d.key) + ")";
            });

        avgLines.append("line")
            .attr("x1", 0)
            .attr("x2", 0)
            .attr("y1", 16)
            .attr("y2", y1AxisLabel.bandwidth() - 5);

        avgLines.append("text")
            .text((d) => {
                return "avg: " + inrFormatter(d.value);
            })
            .attr("x", 3)
            .attr("y", 13);

        // ENABLE THE DROP DOWN SELECTS

        var select = d3.selectAll("select");
        select.on("change", function () {
            var selectedYears = d3.select("#year").property("value");
            var selectedQuarter = d3.select("#quarter").property("value");
            var selectedRegion = d3.select("#region").property("value");
            var selectedEthnicity = d3.select("#retailer").property("value");
            highlightFamilies(selectedYears, selectedQuarter, selectedRegion, selectedEthnicity);
        });

        // CREATE THE FORCE, TO LAYOUT THE CIRCLES - IE. SET THE X,Y COORDS.
        var simulation = d3.forceSimulation(data)
            .force("x", d3.forceX(function (d) {
                return x1AxisLabel(d.metric1);
            }).strength(1))
            .force("y", d3.forceY(function (d) {
                return y1AxisLabel(d.dim1_name) + y1AxisLabel.bandwidth() * y1AxisLabel.align();
            }))
            .force("collide", d3.forceCollide(radius + 1))
            .stop();
        for (var i = 0; i < 120; ++i) simulation.tick();

        // CREATE THE VORONOI LAYOUT TO ENABLE EASIER SELECTION
        var voronoi = d3.voronoi()
            .extent([[-chart.margin.left, -chart.margin.top], [chart.width + chart.margin.right, chart.height + chart.margin.top]])
            .x(function (d) {
                return d.x;
            })
            .y(function (d) {
                return d.y;
            });

        var voronoiData = voronoi(data).polygons();

        // CREATE A NESTED DATASET FOR THE FAMILY LINES
        var nestedData = d3.nest().key((d) => {
            return d.data.dim4_name;
        })
            .entries(voronoiData);

        var lineData = [];

        nestedData.forEach(function (d) {
            lineData.push({dim4_name: d.key, points: []});
        });

        lineData.forEach(function (d) {
            nestedData.forEach(function (p) {
                if (d.dim4_name === p.key) {
                    var pointsToPush = [];
                    p.values.forEach(function (v) {
                        pointsToPush.push({x: v.data.x, y: v.data.y})
                    });
                    pointsToPush.sort(function (a, b) {
                        return a.y - b.y;
                    });
                    d.points = pointsToPush;
                }
            });
        });

        // DRAW THE FAMILY LINES FIRST TO APPEAR UNDER THE CIRCLES
        var gLines = g.selectAll(".g-family-line")
            .data(lineData)
            .enter()
            .append("g")
            .attr("stroke", "#BDBAC0")
            .attr("fill", "none")
            .attr("id", function (d) {
                return "g-family-line-" + d.dim4_name;
            });

        gLines.append("path")
            .attr("id", function (d) {
                return "family-line-" + d.dim4_name;
            })
            .datum(function (d) {
                return d.points;
            })
            .attr("stroke", "#BDBAC0")
            .attr("fill", "none")
            .attr("d", familyLine)
            .style("stroke-opacity", opacity.hidden)

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
      var y1tip = tooltip_class()

      y1tip.attr('class', 'd3-tip'+divId.id)
           .html((d) =>{
                return d.data.dim1_name+
                    "<br/ >Margin"+ colonAnnotation+ d.data.metric1+ "%"+
                    "<br/ >Year"+ colonAnnotation+ d.data.dim2_id+
                    "<br/ >Quarter"+ colonAnnotation+ d.data.dim3_id;
                })

           g.call(y1tip)*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        // DRAW THE  THE CIRCLES
        var cell = g.append("g")
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .selectAll("g")
            .data(voronoiData)
            .enter()
            .append("g")
            .attr("class", "polys");

        cell.append("circle")
            .attr("r", radius)
            .attr("cx", function (d) {
                return d.data.x;
            })
            .attr("cy", function (d) {
                return d.data.y;
            })
            .style("fill", function (d) {
                return metric1ColorScale(d.data.dim2_name);
            })
            .style("fill-opacity", opacity.normal)

        var researchClip = g.append("defs").selectAll("clipPath")
            .data(voronoiData)
            .enter()
            .append("clipPath")
            .attr("id", function (d) {
                return "clip-research-" + d.data.dim1_id;
            })
            .append("circle")
            .attr("cx", function (d) {
                return d.data.x;
            })
            .attr("cy", function (d) {
                return d.data.y;
            })
            .attr("r", radius + 20);

        console.warn(researchClip)

        cell.append("path")
            .attr("class", "clipped-paths")
            .attr("d", function (d) {
                return "M" + d.join("L") + "Z";
            })
            .attr("clip-path", function (d) {
                return "url(#clip-research-" + d.data.dim1_id + ")";
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.data.dim1_name +
                    "<br/ >Margin" + colonAnnotation + d.data.metric1 + "%" +
                    "<br/ >Year" + colonAnnotation + d.data.dim2_id +
                    "<br/ >Quarter" + colonAnnotation + d.data.dim3_id
                )
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            .on("click", showHideCircles);
    });

    // RESET THE CIRCLE FORMATTING
    function resetChart() {
        setSelectValues("All", "All", "All", "All");
        resetLineCircles();
        d3.selectAll(".clipped-paths")
            .each(function (d) {
                d.data.highlighted = false;
            });
    }

    function resetLineCircles() {
        d3.selectAll(".family-line")
            .style("stroke-opacity", opacity.hidden);
        d3.selectAll(".polys")
            .selectAll("circle")
            .style("stroke", "none")
            .style("fill-opacity", opacity.normal);
    }

    // handle the click
    function showHideCircles(d) {
        resetLineCircles();
        if (d.data.highlighted) {
            d3.selectAll(".clipped-paths")
                .each(function (d) {
                    d.data.highlighted = false;
                });
            setSelectValues("All", "All", "All", "All");
        } else {
            var thisFamily = d.data.dim4_name;
            d3.selectAll(".clipped-paths").filter(function (d) {
                return d.data.dim4_name === thisFamily;
            })
                .each(function (d) {
                    d.data.highlighted = true;
                });
            d.data.highlighted = true;
            highlightFamily(d.data.dim4_name);
            setSelectValues(d.data.dim2_id, d.data.dim3_id, d.data.dim2_name, d.data.dim3_name);
        }
        d3.event.stopPropagation();
    }

    // HIGHLIGHT ALL FAMILIES THAT MATCH THE SELECTED VALUES
    function highlightFamilies(noOfYears, noOfQuarter, dim2_name, dim3_name) {
        var thisYears = noOfYears;
        var thisQuarter = noOfQuarter;
        var thisRegion = dim2_name;
        var thisEthnicity = dim3_name;

        resetLineCircles();

        if (thisYears !== "All" && thisQuarter !== "All" && thisRegion !== "All" && thisEthnicity !== "All") {
            var thisID = "" + thisYears + thisQuarter + thisRegion + thisEthnicity;
            thisID = thisID.replace(/\s/g, ''); //remove white spaces
            highlightFamily(thisID);
        } else if (thisYears !== "All" || thisQuarter !== "All" || thisRegion !== "All" || thisEthnicity !== "All") {
            d3.selectAll(".polys")
                .selectAll("circle")
                .style("stroke", "none")
                .style("fill-opacity", opacity.muted);

            var filteredSelection = d3.selectAll(".polys").selectAll("circle")
            if (thisYears !== "All") {
                filteredSelection = filteredSelection.filter(function (d) {
                    return d.data.dim2_id == thisYears;
                })
            }
            if (thisQuarter !== "All") {
                filteredSelection = filteredSelection.filter(function (d) {
                    return d.data.dim3_id == thisQuarter;
                })
            }
            if (thisRegion !== "All") {
                filteredSelection = filteredSelection.filter(function (d) {
                    return d.data.dim2_name == thisRegion;
                })
            }
            if (thisEthnicity !== "All") {
                filteredSelection = filteredSelection.filter(function (d) {
                    return d.data.dim3_name == thisEthnicity;
                })
            }

            filteredSelection
                .style("stroke", "black")
                .style("fill-opacity", opacity.focus);
        }
    } // end of function highlightFamilies

    // HIGHLIGHT A CERTAIN FAMILY TYPE
    function highlightFamily(dim4_id) {
        var thisID = dim4_id;
        d3.selectAll(".polys")
            .selectAll("circle")
            .style("stroke", function (d) {
                return d.data.dim4_name === thisID ? "black" : "none";
            })
            .style("fill-opacity", function (d) {
                return d.data.dim4_name === thisID ? opacity.focus : opacity.muted;
            });

        d3.selectAll("#family-line-" + thisID).style("stroke-opacity", opacity.focus);
    } // end of function highlightFamily

    // SET THE DROP DOWN VALUES BASED ON HIGHLIGHED CIRCLES
    function setSelectValues(parentToSelect, QuarterToSelect, regionToSelect, ethnicityToSelect) {
        d3.select("#year").property("value", parentToSelect);
        d3.select("#quarter").property("value", QuarterToSelect);
        d3.select("#region").property("value", regionToSelect);
        d3.select("#retailer").property("value", ethnicityToSelect);
    }
}
